import React from "react";
import "./style.css";
import Steps from "../Steps";
import { useContext , useEffect } from "react";
import { expertContext } from "../../../../../context/expertcontext";
import { downloadUrl } from "../../../../../confing/confing";
import Num2persian from "num2persian";
const Preview = ({ item }) => {
  const {
    setTab,
    tab,
    estate,
    attributes,
    attributes2,
    attributes3,
    totalPrice,
    areaInfo,
    imgName,
    description,
    total1,
    total2,
    total3,
    setTotalPrice
  } = useContext(expertContext);

  const nextStep = (values) => {
    if (tab < 8) {
      setTab(tab + 1);
    }
  };
  const previousStep = (values) => {
    if (tab > 1) {
      setTab(tab - 1);
    }
  };

  useEffect(() => {
 
    const fetchData = async () => {
      // console.log(item);
      setTotalPrice(total1+total2+total3)
    };
    fetchData();
  }, []);

  return (
    <div>
      <div className="preview-box">
        <div className="strip">
          <img
            className="strip-img"
            src={require("./img/Untitled-2 (1).png")}
            alt=""
          />
        </div>
        <div className="container mt-3">
          <div className="d-flex justify-content-between align-items-center">
            <div className=" w-25">
              <img
                src={require("./img/logo-header.png")}
                alt="logo"
                width={100}
                height={100}
              />
            </div>
            <div className=" text-center">
              <h5 style={{ fontWeight: "bolder" }}>
                کارشناس : {item.expert[0]?.name}
              </h5>
              <p>(گزارش ارزیابی املاک)</p>
            </div>
            <div>
              <p>شماره: {item.requestToken}</p>
              <p>
                تاریخ:{" "}
                {item.expert &&
                  item.expert[0]?.Ex_Expertors.faDateTime
                    .split(" ")[0]
                    .replaceAll("-", "/")}
              </p>
            </div>
          </div>
          <div className="row mt-4 me-3">
            <div className="d-flex justify-content-between">
              <span className="d-inline">مالک: {item.Ex_Owner.name} </span>
              <span className="d-inline">
                نوع سازه ساختمانی: {estate.ExCategoryText}{" "}
              </span>
              <span className="d-inline">سند: {estate.ExDocumentText} </span>
              <span className="d-inline">
                کد پستی : {estate.addressInfo?.postCode}{" "}
              </span>
              <span className="d-inline">
                کد پستی : {estate.addressInfo?.plaque}{" "}
              </span>
            </div>
            <p>
              <span className="d-inline">
                آدرس: {estate.addressInfo?.address}{" "}
              </span>
            </p>
          </div>
          <div className="mt-4 tabel-box ">
            <table className="table rounded-4 preview-table">
              <thead>
                <tr>
                  <th scope="col" className="first-col">
                    ردیف
                  </th>
                  <th scope="col">شرح عرصه و اعیان</th>
                  <th scope="col">مساحت</th>
                  <th scope="col">ارزش هر متر مربع</th>
                  <th scope="col" className="last-col">
                    ارزش کل
                  </th>
                </tr>
              </thead>
              <tbody>
                {attributes.length > 0 &&
                  attributes.map((i, index) => (
                    <tr key={index} className="tr1">
                      <th scope="row">{index + 1}</th>
                      <td>{i.title}</td>
                      <td>{i.QTY}</td>
                      <td>{i.phi?.toLocaleString()}</td>
                      <td>{(i.phi * i.QTY)?.toLocaleString()}</td>
                    </tr>
                  ))}
                {attributes2.length > 0 &&
                  attributes2.map((i, index) => (
                    <tr key={index} className="tr1">
                      <th scope="row">{index + 1}</th>
                      <td>{i.title}</td>
                      <td>{i.QTY && i.QTY}</td>
                      <td>{i.phi>0 && i.phi}</td>
                      <td>{i.price?.toLocaleString()}</td>
                    </tr>
                  ))}

                <tr className="tr2">
                  <td colSpan="4">
                    تاسیسات و امتیازات:
                    {attributes3.aryy?.length > 0 &&
                      attributes3.aryy.map(
                        (i, index) =>
                          i.status && (
                            <span key={index} className="me-3">
                              {i.title}-{i.QTY}
                            </span>
                          )
                      )}
                  </td>
                  <td>{attributes3.attributes?.price?.toLocaleString()}</td>
                </tr>
                <tr>
                  <td colSpan="5">
                    ابعاد:
                    <span className="me-3">شمال : {areaInfo.areaInfo?.north}</span>
                    <span className="me-3">جنوب : {areaInfo.areaInfo?.south}</span>
                    <span className="me-3">شرق: {areaInfo.areaInfo?.east}</span>
                    <span className="me-3">غرب: {areaInfo.areaInfo?.west}</span>
                    <span className="me-3">پخ موجود : {areaInfo.areaInfo?.chamfer}</span>
                  </td>
                </tr>
                <tr>
                  <td colSpan="5">جمع کل: {totalPrice} 
                  <p>{totalPrice>0 && Num2persian(Math.round(totalPrice))}  تومان</p> 
                  </td>
                </tr>
                <tr className="tr3">
                  <td colSpan="3" className="last-row">
                    کروکی:
                    {imgName && (
                      <img
                        alt=""
                        width="350px"
                        height="200px"
                        src={`${downloadUrl}${imgName}`}
                      />
                    )}
                  </td>
                  <td colSpan="2" className="last-row">
                  توضیحات:
                  <p>{description}</p>
                </td>
                </tr>
              </tbody>
            </table>
            <img
              src={require("./img/bg-img.png")}
              alt="bg-img"
              className="bg-img"
            />
          </div>
          <div className="row  bottom-box">
            <div className="col-5">
             {
              /*
              <p>
              <strong>www-najafabad.ir</strong>
            </p>
            <p className="mt-4">
              {" "}
              <strong>app:/koja-najafabad</strong>
            </p>
            <p className="mt-4">
              {" "}
              <strong>koja-najafabad.ir</strong>
            </p>
              */
             }
            </div>
            <div className="col-7 ">
              {
                /*
                <div className="signature">
                <p>مهر و امضا:</p>
              </div>
              <div className="address">
                <p>ادرس و تلفن:</p>
              </div>
                */
              }
            </div>
          </div>
        </div>
        <br></br>
      </div>
      <div>
        <Steps />
        <div className="mb-2 px-2 d-flex justify-content-between">
          <div className=" request-next-btn-box mt-2">
            <button
              onClick={() => {
                nextStep()
              }}
              type="submit"
              className="btn request-next-btn"
            >
              ثبت
            </button>
          </div>
          <div className=" request-Previous-btn-box mt-2">
            <button
              className="btn request-Previous-btn "
              type="button"
              onClick={() => {
                previousStep();
              }}
            >
              قبلی
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preview;
